import * as React from 'react';
import { SVGProps } from 'react';
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
const LogoFaceRobot = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 40" {...props}>
    <path d="M47.382 0H.927C.103 0-.31 1.002.272 1.587l5.003 5.025.02-.02V35.36C5.294 37.92 7.361 40 9.914 40h37.467c2.55 0 4.62-2.077 4.62-4.641V4.64C52.002 2.08 49.935 0 47.382 0ZM18 26.24c-3.432 0-6.21-2.795-6.21-6.24 0-3.445 2.78-6.24 6.21-6.24s6.21 2.795 6.21 6.24c0 3.445-2.78 6.24-6.21 6.24Zm21.299 0c-3.432 0-6.211-2.795-6.211-6.24 0-3.445 2.781-6.24 6.21-6.24 3.43 0 6.211 2.795 6.211 6.24 0 3.445-2.781 6.24-6.21 6.24Z" />
  </svg>
);
export default LogoFaceRobot;
